import { render, staticRenderFns } from "./unloadingSummaryView.vue?vue&type=template&id=a5309512&scoped=true"
import script from "./unloadingSummaryView.vue?vue&type=script&lang=js"
export * from "./unloadingSummaryView.vue?vue&type=script&lang=js"
import style0 from "./unloadingSummaryView.vue?vue&type=style&index=0&id=a5309512&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5309512",
  null
  
)

export default component.exports